import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-layout" }
const _hoisted_2 = { class: "layout-item" }
const _hoisted_3 = { class: "layout-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSubdomain = _resolveComponent("AppSubdomain")!
  const _component_Tech = _resolveComponent("Tech")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppSubdomain, {
        imagefile: "derek_and_jasper.jpg",
        name: "Derek Pedersen",
        destination: "https://derek.pedersen.io",
        propMessage: "Founding Engineer by Day, Ski-bum by Weekend"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Tech)
    ])
  ]))
}